import * as errors from '@attain-apps/errors'

import { Id, type Identifiable } from './id'
import type { Node } from './node'

/**
 * TODO: explain
 */
export class Cache {
  /** Cache of {@link Node} */
  private readonly _nodes: Partial<Record<Id, Node>> = {}

  public get(identifiable: Identifiable): Node {
    const node = this.tryGet(identifiable)
    if (!node) {
      this._throwNotFound(identifiable)
    }
    return node
  }
  public tryGet(identifiable: Identifiable): Node | undefined {
    return this._nodes[Id.from(identifiable)]
  }

  public add(node: Node): void {
    // NOTE: only need to check one since _nodes and _queries are kept in
    // sync
    if (this._nodes[node.id]) {
      // NOTE: having a user-friendly error is only sort of helpful since
      // the Graph (and its nodes and edges) are really
      // behind-the-scenes concepts
      throw new errors.AlreadyExistsError({
        id: node.id,
        type: 'DMS query node',
      })
    }
    this._nodes[node.id] = node
  }

  public remove(node: Node): void {
    delete this._nodes[node.id]
  }

  private _throwNotFound(identifiable: Identifiable): never {
    // NOTE: having a user-friendly error is only sort of helpful since
    // the Graph (and its nodes and edges) are really
    // behind-the-scenes concepts
    throw new errors.NotFoundError({
      id: Id.from(identifiable),
      type: 'DMS query node',
    })
  }
}
